// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".printHandler__dialogTitle___2aN97 h2{color:var(--spectrum-global-color-gray-900)!important}@page{margin:0;padding:0}.documentDiv{align-items:center;background-color:transparent;color:transparent;display:none;flex-direction:column}.documentDiv .printedPage{page-break-before:always;-moz-column-break-before:page;break-before:page;page-break-inside:avoid;-moz-column-break-inside:avoid;break-inside:avoid;display:flex;flex-direction:column;height:100%;width:100%}.documentDiv .printedPage:first-of-type{page-break-before:avoid;-moz-column-break-before:avoid;break-before:avoid}@media print{body>*{display:none}.documentDiv{display:block;height:100%}}", ""]);
// Exports
exports.locals = {
	"dialogTitle": "printHandler__dialogTitle___2aN97"
};
module.exports = exports;
